/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Errore nell\'annullamento dell\'integrazione di Twitch',
    ERROR: 'Errore',
    FETCH_DATA: 'Recupera i dati'
  },
  HEADER: {
    DATE: 'Data',
    MESSAGE: 'Messaggio',
    NAME: 'Nome',
    ORDER_CODE: 'Codice dell\'ordine',
    ORDER_VALUE: 'Valore'
  },
  LABEL: {
    ACTIVE_SINCE: 'Attivo da',
    INTEGRATIONS: 'Integrazioni',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Permesso Twitch',
    TWITCH_AUTHORIZED_INFORMATION:
      'Prozis ha il permesso di creare avvisi su Twitch durante le dirette.',
    TWITCH_INFORMATION:
      'Prozis richiederà il permesso di creare avvisi su Twitch durante le dirette.',
    TWITCH_INTEGRATION: 'Integrazione di Twitch'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'Integrazione di Twitch cancellata',
    SUCCESS: 'Successo'
  },
  TOOLTIP: {
    ORDER_CODE: 'Codice dell\'ordine'
  }
};
